import { useEffect, useState } from "react";

import { buildAssistantUrl } from "../utils/assistantApi";

/**
 * Release number for the version badge, served by the backend.
 *
 * The UI keeps no version of its own, so the badge renders only once this
 * resolves. Cached per page load; a failed fetch retries on the next mount.
 */
let cached: string | null = null;
let inFlight: Promise<string | null> | null = null;

const fetchVersion = (): Promise<string | null> => {
  if (cached) return Promise.resolve(cached);
  if (!inFlight) {
    inFlight = fetch(buildAssistantUrl("version"))
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        cached = data?.version || null;
        return cached;
      })
      .catch(() => null)
      .finally(() => {
        inFlight = null;
      });
  }
  return inFlight;
};

export const useLouVersion = (): string | null => {
  const [version, setVersion] = useState<string | null>(cached);

  useEffect(() => {
    if (version) return undefined;
    let active = true;
    fetchVersion().then((value) => {
      if (active && value) setVersion(value);
    });
    return () => {
      active = false;
    };
  }, [version]);

  return version;
};

export default useLouVersion;
